import React, { useCallback, useEffect, useState } from 'react';
import {
  CustomCollapseCard,
  CustomDatePicker,
  CustomForm,
  CustomFormItem,
  CustomInput,
  CustomSelect,
  errorDialog,
  Option,
  Text,
  useText,
} from '@src/components';
import { useSelector } from 'react-redux';
import { monthsList, orderTypeList } from '@src/store/enums';
import dayjs from '@src/utils/day';
import '@src/styles/cardOrder/addInformationCompliment.scss';
import PropTypes from 'prop-types';
import 'dayjs/locale/tr'; // Türkçe desteği
import { formatInvoiceMonthText } from '@src/pages/ticketMarket/cardOrders/cardInformation/AdditionalInformation';
import { getCurrentLanguage } from '@src/services/api';
dayjs.locale('tr');

const isDateValid = (value, invoiceMonthText, invoiceMonthText2) => {
  const sysDateYear = new Date().getFullYear();
  const sysDateMonth = new Date().getMonth() + 1;
  const selectedMonth = value.month() + 1;
  const selectedYear = value.year();

  return (
    (selectedMonth === invoiceMonthText?.value && selectedYear === sysDateYear) ||
    (selectedMonth - 1 === invoiceMonthText?.value && selectedYear === sysDateYear) ||
    (sysDateMonth === 12 &&
      invoiceMonthText?.value === 1 &&
      selectedMonth === 1 &&
      selectedYear === sysDateYear + 1) ||
    (invoiceMonthText2?.text !== 'xxx' &&
      ((selectedMonth === invoiceMonthText2?.value && selectedYear === sysDateYear) ||
        (sysDateMonth === 12 &&
          invoiceMonthText2?.value === 1 &&
          selectedMonth === 1 &&
          selectedYear === sysDateYear + 1)))
  );
};

const AdditionalInformation = ({ form }) => {
  const { currentCardOrder } = useSelector((state) => state?.cardOrder);
  const [isTotalVisible, setIsTotalVisible] = useState(false);
  const [isDateControl, setIsDateControl] = useState(false);
  const [changedDateFromUser, setChangedDateFromUser] = useState(null);
  const [changedDateFromUser2, setChangedDateFromUser2] = useState(null);
  const [bakiyeAktiflikTarihi, setBakiyeAktiflikTarihi] = useState('');
  const [invoiceMonthText, setInvoiceMonthText] = useState({ text: 'xxx', value: 1 });
  const [invoiceMonthText2, setInvoiceMonthText2] = useState({ text: 'xxx', value: 2 });
  const language = getCurrentLanguage();
  const currentDate = dayjs();
  const selectChoose = useText('choose');
  const eBillInformation = useText('enterYourAdditionalInformationRegardingEInvoice');
  const pickDateText = useText('pickDate');
  const eInvoiceAdditionalInfoText = useText('eInvoiceAdditionalInfo');
  const orderTypeText = useText('orderType');
  const balanceActivationDateRequired = useText('balanceActivationDateRequired');
  const youCannotEnterAPastDate = useText('youCannotEnterAPastDate');
  const additionalInformation = useText('additionalInformation');
  const invoiceWillBeIssuedInMonth = useText('invoiceWillBeIssuedInMonth');

  useEffect(() => {
    const initialValues = {
      orderType: currentCardOrder?.orderType,
    };

    const total = currentCardOrder?.totalPrice > 0;
    const currentDay = currentDate?.date();
    const currentMonth = currentDate?.month() + 1;
    const controlDate = currentDay >= 15;
    setIsDateControl(controlDate);
    setIsTotalVisible(total);
    const responseInvoiceMonth = currentCardOrder?.invoiceMonth || currentMonth;
    const invoiceMonth = !controlDate ? currentMonth : responseInvoiceMonth;

    let nextM = (currentMonth % 12) + 1;
    let filterData = monthsList.filter((item) => [currentMonth, nextM].includes(item.value));
    if (filterData.length === 1) {
      setIsDateControl(false);
    }

    const activationDate = dayjs(currentCardOrder?.cardActivationDate);
    const isBefore =
      activationDate.isBefore(currentDate, 'day') || activationDate.isSame(currentDate, 'day');

    if (total) {
      let formCardActivationDate;

      if (isBefore) {
        if (changedDateFromUser && currentCardOrder?.id) {
          formCardActivationDate = dayjs(changedDateFromUser);
        } else {
          formCardActivationDate = null;
        }
      } else if (changedDateFromUser && dayjs(changedDateFromUser) !== activationDate) {
        formCardActivationDate = dayjs(changedDateFromUser);
      } else {
        formCardActivationDate = activationDate;
      }

      mountSelectOptions(invoiceMonth);
      initialValues.invoiceMonth = invoiceMonth;
      initialValues.cardActivationDate = formCardActivationDate;
      initialValues.eInvoiceInformation = currentCardOrder?.eInvoiceInformation;
      const monthName = formCardActivationDate ? formCardActivationDate.locale(language).format('MMMM') : null;
      setBakiyeAktiflikTarihi(monthName);
    }
    if (!currentCardOrder?.id && changedDateFromUser) {
      setChangedDateFromUser(null);
    } else if (!isBefore && initialValues?.cardActivationDate && !changedDateFromUser2) {
      setChangedDateFromUser2(initialValues.cardActivationDate);
    }
    form.setFieldsValue(initialValues);
  }, [currentCardOrder, currentDate, form, isDateControl, isTotalVisible, changedDateFromUser]);

  const filterDateChangeFromUser = (value) => {
    setChangedDateFromUser(value);
  };

  const disabledDate = useCallback((current) => {
    if (!current) return false;

    const now = dayjs();
    const nextMonthEnd = now.add(1, 'month').endOf('month');

    return current.isBefore(now.startOf('day')) || current.isAfter(nextMonthEnd);
  }, []);

  const mountSelectOptions = (invoiceMonth = null) => {
    let nextMonthFlag = true;
    const currentMonth = currentDate?.month() + 1;
    let nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;

    let filterData = monthsList.filter((item) =>
      [...new Set([currentCardOrder?.invoiceMonth, currentMonth, nextMonth])].includes(item.value),
    );

    if (!isDateControl) {
      filterData = monthsList.filter((item) => [currentMonth].includes(item.value));
    }
    if (currentMonth === 12) {
      filterData = filterData.reverse();
    }
    // currentDay > 15
    filterData.push(monthsList.filter((item) => item.value === (currentMonth + 1) % 12)[0]);
    filterData = filterData.filter(function (element) {
      return element !== undefined;
    });
    try {
      const tempText = filterData.filter((item) =>
        nextMonthFlag
          ? item.value === currentMonth || item.value === (currentMonth + 1) % 12
          : item.value === currentMonth,
      );
      if (tempText.length > 1) {
        setInvoiceMonthText2(tempText[1]);
      }
      setInvoiceMonthText(tempText[0]);
    } catch (e) {
      console.error(e);
    }
  };

  const pastDateValidator = async (_field, value) => {
    if (value !== null) {
      try {
        const now = new Date();
        const today = dayjs(now.toDateString());
        const selectedDate = dayjs(value);
        const isBefore = selectedDate.isBefore(today, 'day');
        if (isBefore) {
          errorDialog({
            title: <Text t="error" />,
            message: youCannotEnterAPastDate,
          });
          return Promise.reject(new Error('error'));
        }
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(new Error('error'));
      }
    } else {
      errorDialog({
        title: <Text t="error" />,
        message: balanceActivationDateRequired,
      });
      return Promise.resolve();
    }
  };

  const activationDateValidator = async (_field, value) => {
    if (!value) return Promise.resolve();
    return isDateValid(value, invoiceMonthText, invoiceMonthText2)
      ? Promise.resolve()
      : Promise.reject(new Error('error'));
  };

  return (
    <CustomCollapseCard
      cardTitle={additionalInformation}
      cardTitleAlign="center"
      titleColor="#1d2228"
      titleSize="16px"
      showExpandIcon={false}
    >
      <div className="add-information-container">
        <CustomForm
          name="additionalInformation"
          className="addInformationForm"
          initialValues={{}}
          autoComplete="off"
          layout={'horizontal'}
          form={form}
        >
          {isTotalVisible && (
            <div className="form-item-compliment">
              <CustomFormItem
                label={
                  <span>
                    <Text t="dateWhenBalanceWillBeAvailable" />{' '}
                    <span className="comp-required-asterisk">*</span>
                  </span>
                }
                name="cardActivationDate"
                requiredMark={false}
                colon={false}
                required={false}
                className="active-date-form-item"
                rules={[
                  { required: true, message: <Text t="thisFieldCannotBeLeftBlank" /> },
                  {
                    validator: activationDateValidator,
                    message: <Text t="balanceDateAndInvoiceMonthMustBeCompatible" />,
                  },
                  {
                    validator: pastDateValidator,
                    message: <Text t="youCannotEnterAPastDate" />,
                  },
                ]}
              >
                <CustomDatePicker
                  id="ticketRestaurant-cardOrders-cardInformation-additionalInformation-cardActivationDate-datePicker"
                  placeholder={pickDateText}
                  disabledDate={disabledDate}
                  onChange={(value) => filterDateChangeFromUser(value)}
                  allowClear={false}
                />
              </CustomFormItem>

              <CustomFormItem
                label={eInvoiceAdditionalInfoText}
                name="eInvoiceInformation"
                className={'delivery-address-add-form-item'}
              >
                <CustomInput
                  id="ticketRestaurant-cardOrders-cardInformation-additionalInformation-eInvoiceInformation-input"
                  placeholder={eBillInformation}
                  maxLength={150}
                  hasNumberChar={true}
                />
              </CustomFormItem>
            </div>
          )}
          {isTotalVisible && (changedDateFromUser || changedDateFromUser2) && (
            <div className="compliment-notification-div ">
              {formatInvoiceMonthText(invoiceWillBeIssuedInMonth, bakiyeAktiflikTarihi)}
            </div>
          )}

          <div className="form-item-compliment ">
            <CustomFormItem
              label={orderTypeText}
              name="orderType"
              className={'order-type-form-item'}
            >
              <CustomSelect
                id="ticketRestaurant-cardOrders-cardInformation-additionalInformation-orderType-select"
                placeholder={selectChoose}
                style={{ width: 160 }}
              >
                {orderTypeList.map((orderType) => (
                  <Option
                    id={`ticketRestaurant-cardOrders-cardInformation-additionalInformation-orderType-${orderType?.text}-option`}
                    key={orderType.value}
                    value={orderType.value}
                  >
                    {orderType.text}
                  </Option>
                ))}
              </CustomSelect>
            </CustomFormItem>
            {isTotalVisible && (
              <CustomFormItem
                label={<Text t="invoiceAddress2" />}
                className={'delivery-address-form-item'}
              >
                <span
                  id="ticketRestaurant-cardOrders-cardInformation-additionalInformation-deliveryAddress-span"
                  className="address-info-box"
                >
                  {currentCardOrder?.invoiceAddress}
                </span>
              </CustomFormItem>
            )}
          </div>
        </CustomForm>
      </div>
    </CustomCollapseCard>
  );
};
AdditionalInformation.propTypes = {
  form: PropTypes.any,
};
export default AdditionalInformation;
